import React from "react";

// Inner Loader Component
export default function TableLoader() {
  // Returning JSX
  return (
    <>
      <div id="inner-table" className="inner-table inner-table-spinner ">
        <div className="loader-spinner "></div>
        <p className="font-weight-bolder mt-5 mb-0">Please wait...</p>
      </div>
    </>
  );
}